import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import { Link } from 'components/Link'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { TranslationKeys } from 'locales/translationKeys'
import { UnorderedList, OrderedList } from './ParagraphAndList.styles'

export type ParagraphAndListProps = {
  paragraphs?: TranslationKeys[]
  list?: TranslationKeys[]
  orderedList?: TranslationKeys[]
  link?: string
  nestingLevel: number
}

export const ParagraphAndList = ({
  paragraphs,
  list,
  orderedList,
  link,
  nestingLevel,
}: ParagraphAndListProps) => {
  const { t } = useTranslation()

  if (!paragraphs && !list) return null

  return (
    <>
      <Stack direction="column" gap="3">
        {paragraphs &&
          paragraphs?.map((paragraph, index) => {
            return link ? (
              <Stack
                key={index}
                css={{
                  display: 'inline',
                  paddingLeft: `${nestingLevel * 24}px`,
                }}
              >
                <Trans components={[<Link href={link} key="0" />]} i18nKey={paragraph}></Trans>
              </Stack>
            ) : (
              <div key={index} css={{ paddingLeft: `${nestingLevel * 24}px` }}>
                <Text css={{ paddingLeft: `${nestingLevel * 24}px` }}>{t(paragraph)}</Text>
              </div>
            )
          })}
        {list && (
          <UnorderedList css={{ paddingLeft: `${nestingLevel * 24 + 24}px` }}>
            {list.map((listItem, index) => {
              return (
                <li key={index}>
                  {link ? (
                    <Trans components={[<Link href={link} key="0" />]} i18nKey={listItem}></Trans>
                  ) : (
                    t(listItem)
                  )}
                </li>
              )
            })}
          </UnorderedList>
        )}
        {orderedList && (
          <OrderedList
            css={{ paddingLeft: `${nestingLevel * 24 + 24}px`, listStyle: 'decimal !important' }}
          >
            {orderedList.map((listItem, index) => {
              return (
                <li key={index}>
                  {link ? (
                    <Trans components={[<Link href={link} key="0" />]} i18nKey={listItem}></Trans>
                  ) : (
                    t(listItem)
                  )}
                </li>
              )
            })}
          </OrderedList>
        )}
      </Stack>
    </>
  )
}

ParagraphAndList.displayName = 'ParagraphAndList'
